/**
 * Bus de toasts global — permite emitir notificaciones desde fuera del árbol de
 * React (por ejemplo desde el `MutationCache.onError` del QueryClient).
 *
 * El hook `useToast` de components/Toast.tsx maneja estado LOCAL de un componente;
 * sirve cuando la pantalla ya sabe qué mostrar. Esto es la otra mitad: la red de
 * seguridad para errores que nadie está escuchando.
 */
import type { ToastType } from '@/components/Toast'
import { registrarToastDeError } from '@/lib/erroresMostrados'

type Listener = (type: ToastType, message: string) => void

const listeners = new Set<Listener>()

/** Emite un toast global. No-op si nadie está suscrito (p. ej. en tests). */
export function emitToast(type: ToastType, message: string) {
  if (type === 'error') registrarToastDeError()
  listeners.forEach(fn => fn(type, message))
}

/** Suscribe un listener. Devuelve la función para desuscribirse. */
export function subscribeToasts(fn: Listener): () => void {
  listeners.add(fn)
  return () => { listeners.delete(fn) }
}
